export const QueryParam = {};

/* eslint-disable no-undef */
export const TelegramBotName = process.env.TELEGRAM_BOT_USERNAME;
/* eslint-enable no-undef */
